<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('administrativecenter.CentreCode')}}</label>
              <el-form-item prop="CentreCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.CentreCode.value"
                  maxlength="10"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('administrativecenter.RoleTypeCode')}}</label>
              <el-form-item prop="RoleCode">
                <el-select class="w-full" 
                  v-model="form.RoleCode.value" 
                  filterable
                  clearable>
                    <el-option
                      v-for="opt in tiposRolesAdministrativeCenters"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="Name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Name.value"
                  maxlength="10"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('persons_data.firstsurname') }}</label>
              <el-form-item prop="FirstSurname">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.FirstSurname.value"
                  maxlength="10"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('persons_data.secondsurname') }}</label>
              <el-form-item prop="SecondSurname">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.SecondSurname.value"
                  maxlength="10"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.location')}}</label>
              <el-form-item prop="Address">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Address.value"
                  maxlength="80"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.codigo_postal') }}</label>
              <el-form-item prop="PostCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.PostCode.value"
                  maxlength="80"
                  type="number"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.poblacion') }}</label>
              <el-form-item prop="Town">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Town.value"
                  maxlength="20"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.provincia')}}</label>
              <el-form-item prop="Province">
                <el-input v-if="!isSpain"
                  clearable
                  class="w-full"
                  v-model="form.Province.value"
                  maxlength="20"
                />
                <el-select v-else
                  class="w-full" 
                  v-model="form.Province.value" 
                  filterable
                  clearable 
                  :placeholder="$t('app.select')">
                  <el-option
                    v-for="opt in listProvincias"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('address.pais')}}</label>
              <el-form-item prop="CountryCode">
                <el-select class="w-full" 
                  v-model="form.CountryCode.value" 
                  filterable
                  clearable>
                    <el-option
                      v-for="opt in listPaises"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
              <el-form-item prop="Telephone">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Telephone.value"
                  maxlength="80"
                  type="number"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.telefax') }}</label>
              <el-form-item prop="TeleFax">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.TeleFax.value"
                  maxlength="80"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.WebAddress') }}</label>
              <el-form-item prop="WebAddress">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.WebAddress.value"
                  maxlength="80"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ElectronicMail') }}</label>
              <el-form-item prop="ElectronicMail">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.ElectronicMail.value"
                  maxlength="80"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.entity_name_plural') }}</label>
              <el-form-item prop="ContactPersons">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.ContactPersons.value"
                  maxlength="80"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.cno_cnae') }}</label>
              <el-form-item prop="CnoCnae">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.CnoCnae.value"
                  maxlength="80"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.additional_details') }}</label>
              <el-form-item prop="AdditionalDetails">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.AdditionalDetails.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>           

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.PhysicalGLN') }}</label>
              <el-form-item prop="PhysicalIGLN">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.PhysicalIGLN.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.LogicalOperationalPoint') }}</label>
              <el-form-item prop="LogicalOperationalPoint">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.LogicalOperationalPoint.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.CentreDescription') }}</label>
              <el-form-item prop="CentreDescription">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.CentreDescription.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>
            
                        

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'administrativecenters',
      isOpen: this.panelOpen,
      form: {
        CentreCode: { label: i18n.t('administrativecenter.CentreCode'), value: '' },
        RoleCode: { label: i18n.t('administrativecenter.RoleTypeCode'), value: '' },
        Name: { label: i18n.t('app.name'), value: '' },
        FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
        SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
        Address: { label: i18n.t('address.location'), value: '' },
        PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
        Town: { label: i18n.t('address.poblacion'), value: '' },
        Province: { label: i18n.t('address.provincia'), value: '' },
        CountryCode: { label: i18n.t('address.pais'), value: '' },
        Telephone: { label: i18n.t('address.telefono'), value: '' },
        TeleFax: { label: i18n.t('administrativecenter.telefax'), value: '' },
        WebAddress: { label: i18n.t('contacto.WebAddress'), value: '' },
        ElectronicMail: { label: i18n.t('contacto.ElectronicMail'), value: '' },
        ContactPersons: { label: i18n.t('contacto.entity_name_plural'), value: '' },
        CnoCnae: { label: i18n.t('administrativecenter.cno_cnae'), value: '' },
        INETownCode: { label: i18n.t('administrativecenter.INE_town_code'), value: '' },
        AdditionalDetails: { label: i18n.t('administrativecenter.additional_details'), value: '' },
        PhysicalIGLN: { label: i18n.t('administrativecenter.PhysicalGLN'), value: '' },
        LogicalOperationalPoint: { label: i18n.t('administrativecenter.LogicalOperationalPoint'), value: '' },
        CentreDescription: { label: i18n.t('administrativecenter.CentreDescription'), value: '' },
      },
      loadingData: false,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    isSpain: function () {
      return this.form.CountryCode.value.toUpperCase() === 'ESP'
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },
    tiposRolesAdministrativeCenters: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER']
    },
  },
  mounted: async function () {
    // this.loadingData = true
    // const dataAgrupaciones = await getAgrupacionesNombreCompanies()
    // if (dataAgrupaciones.blnError === true) {
    //   this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataAgrupaciones))
    // }
    // this.listGrouping = dataAgrupaciones.Respuesta.map((x, i) => ({ key: i, label: x, value: x }))
    // this.loadingData = false
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.CentreCode.value = _temp.CentreCode !== undefined && _temp.CentreCode.value !== '' ? _temp.CentreCode.value : ''
        this.form.RoleCode.value = _temp.RoleCode !== undefined && _temp.RoleCode.value !== '' ? _temp.RoleCode.value : ''
        this.form.Name.value = _temp.Name !== undefined && _temp.Name.value !== '' ? _temp.Name.value : ''
        this.form.FirstSurname.value = _temp.FirstSurname !== undefined && _temp.FirstSurname.value !== '' ? _temp.FirstSurname.value : ''
        this.form.SecondSurname.value = _temp.SecondSurname !== undefined && _temp.SecondSurname.value !== '' ? _temp.SecondSurname.value : ''
        this.form.Address.value = _temp.Address !== undefined && _temp.Address.value !== '' ? _temp.Address.value : ''
        this.form.PostCode.value = _temp.PostCode !== undefined && _temp.PostCode.value !== '' ? _temp.PostCode.value : ''
        this.form.Province.value = _temp.Province !== undefined && _temp.Province.value !== '' ? _temp.Province.value : ''
        this.form.CountryCode.value = _temp.CountryCode !== undefined && _temp.CountryCode.value !== '' ? _temp.CountryCode.value : ''
        this.form.Telephone.value = _temp.Telephone !== undefined && _temp.Telephone.value !== '' ? _temp.Telephone.value : ''
        this.form.TeleFax.value = _temp.TeleFax !== undefined && _temp.TeleFax.value !== '' ? _temp.TeleFax.value : ''
        this.form.WebAddress.value = _temp.WebAddress !== undefined && _temp.WebAddress.value !== '' ? _temp.WebAddress.value : ''
        this.form.ElectronicMail.value = _temp.ElectronicMail !== undefined && _temp.ElectronicMail.value !== '' ? _temp.ElectronicMail.value : ''
        this.form.ContactPersons.value = _temp.ContactPersons !== undefined && _temp.ContactPersons.value !== '' ? _temp.ContactPersons.value : ''
        this.form.CnoCnae.value = _temp.CnoCnae !== undefined && _temp.CnoCnae.value !== '' ? _temp.CnoCnae.value : ''
        this.form.INETownCode.value = _temp.INETownCode !== undefined && _temp.INETownCode.value !== '' ? _temp.INETownCode.value : ''
        this.form.AdditionalDetails.value = _temp.AdditionalDetails !== undefined && _temp.AdditionalDetails.value !== '' ? _temp.AdditionalDetails.value : ''
        this.form.PhysicalIGLN.value = _temp.PhysicalIGLN !== undefined && _temp.PhysicalIGLN.value !== '' ? _temp.PhysicalIGLN.value : ''
        this.form.LogicalOperationalPoint.value = _temp.LogicalOperationalPoint !== undefined && _temp.LogicalOperationalPoint.value !== '' ? _temp.LogicalOperationalPoint.value : ''
        this.form.CentreDescription.value = _temp.CentreDescription !== undefined && _temp.CentreDescription.value !== '' ? _temp.CentreDescription.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        CentreCode: { label: i18n.t('administrativecenter.CentreCode'), value: '' },
        RoleCode: { label: i18n.t('administrativecenter.RoleTypeCode'), value: '' },
        Name: { label: i18n.t('app.name'), value: '' },
        FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
        SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
        Address: { label: i18n.t('address.location'), value: '' },
        PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
        Town: { label: i18n.t('address.poblacion'), value: '' },
        Province: { label: i18n.t('address.provincia'), value: '' },
        CountryCode: { label: i18n.t('address.pais'), value: '' },
        Telephone: { label: i18n.t('address.telefono'), value: '' },
        TeleFax: { label: i18n.t('administrativecenter.telefax'), value: '' },
        WebAddress: { label: i18n.t('contacto.WebAddress'), value: '' },
        ElectronicMail: { label: i18n.t('contacto.ElectronicMail'), value: '' },
        ContactPersons: { label: i18n.t('contacto.entity_name_plural'), value: '' },
        CnoCnae: { label: i18n.t('administrativecenter.cno_cnae'), value: '' },
        INETownCode: { label: i18n.t('administrativecenter.INE_town_code'), value: '' },
        AdditionalDetails: { label: i18n.t('administrativecenter.additional_details'), value: '' },
        PhysicalIGLN: { label: i18n.t('administrativecenter.PhysicalGLN'), value: '' },
        LogicalOperationalPoint: { label: i18n.t('administrativecenter.LogicalOperationalPoint'), value: '' },
        CentreDescription: { label: i18n.t('administrativecenter.CentreDescription'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
